import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import AnimatedSection from '../components/AnimatedSection';
import { usePublicSettings } from '../context/PublicSettingsContext';
import './Weddings.css';

const API_ORIGIN = '';

const pageVariants = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { duration: 0.6 } },
  exit: { opacity: 0, transition: { duration: 0.3 } },
};

function imgUrl(u) {
  if (!u) return '';
  if (u.startsWith('http')) return u;
  if (u.startsWith('/uploads')) return `${API_ORIGIN}${u}`;
  return u;
}

const DEFAULT_WEDDING_GALLERY = [
  '/weddingpic1.webp',
  '/weddingpic2.webp',
  '/weddingpic3.webp',
  '/weddingpic4.webp',
  '/weddingpic5.webp',
  '/weddingpic6.webp',
  '/weddingpic7.webp',
  '/weddingpic8.webp',
  '/weddingpic9.webp',
];

const Weddings = () => {
  const { settings } = usePublicSettings();
  const page = settings?.wedding_page || {};
  const settingsGallery = (page.gallery || []).filter(Boolean);
  const gallery = settingsGallery.length > 0 ? settingsGallery : DEFAULT_WEDDING_GALLERY;

  return (
    <motion.main
      className="weddings-page"
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
    >
      <section className="page-header">
        <div className="page-header__bg">
          <img src="/background.png" alt="" />
          <div className="page-header__overlay" />
        </div>
        <div className="page-header__content">
          <motion.span className="script-font page-header__eyebrow" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
            Finger Lakes
          </motion.span>
          <motion.h1 initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }}>
            {page.heroTitle || 'Weddings'}
          </motion.h1>
          <motion.p className="page-header__sub" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.2 }}>
            {page.heroSubtitle || 'Seasonal florals for your day'}
          </motion.p>
        </div>
      </section>

      <section className="weddings-page__content">
        <div className="container">
          <AnimatedSection>
            <p className="weddings-page__intro">
              {page.intro || 'From intimate lakeside ceremonies to full reception installs — we work with you to bring locally grown beauty to every moment. Content and gallery images are editable in Admin → Site.'}
            </p>
          </AnimatedSection>

          <div className="weddings-page__grid">
            {gallery.map((src, i) => (
              <AnimatedSection key={`${src}-${i}`} delay={i * 0.05} direction="up" className="weddings-page__item">
                <motion.div className="weddings-page__img-wrap" whileHover={{ y: -6 }} transition={{ duration: 0.3 }}>
                  <img src={imgUrl(src)} alt={`Wedding gallery ${i + 1}`} loading="lazy" />
                </motion.div>
              </AnimatedSection>
            ))}
          </div>

          {gallery.length === 0 && (
            <p className="weddings-page__empty">Add image paths under Admin → Site → Weddings page.</p>
          )}

          <AnimatedSection style={{ textAlign: 'center', marginTop: '48px' }}>
            <Link to="/contact?topic=wedding" className="btn btn-primary">Inquire about your wedding</Link>
          </AnimatedSection>
        </div>
      </section>
    </motion.main>
  );
};

export default Weddings;
